<lib-contract-state-base
    title="La solicitud se encuentra en periodo de revision"
    subtitle="Tan pronto como sea procesada podrás ver los detalles aquí"
    [svg]="svg">
</lib-contract-state-base>
